module.exports = __webpack_public_path__ + "media/images/basic-logos/loading-77fbe978a3436f87c4b362f168200ebf.gif";